import Backbone from 'backbone'
import template from './form-actions.hbs'
import ifDisplay from './action-if-display.hbs'
import thenDisplay from './action-then-display.hbs'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import FormLogicianEditor from './form-logician-editor'
import appDisplay from 'scoreboard/components/app-display'
import transformationButtons from 'scoreboard/imports/transform/transformation-buttons.hbs'
import { getIfContext } from 'scoreboard/imports/transform/transformations'
import DraggableList from 'draggable-list'
import formatValue from '../../components/format-value'
import FormWidgetInputValidationType
	from '../model/form-widget-input-validation-type'
const {
	CUSTOM_EXPRESSION,
	MAXIMUM_LENGTH,
	MINIMUM_LENGTH, MINIMUM_MAXIMUM_LENGTH
} = FormWidgetInputValidationType
import isDateTimeDataType from '../../components/is-date-time-data-type'
import reorderAfterDrag from 'scoreboard/components/reorder-after-drag'
import StatementType from 'scoreboard/components/logic/model/statement-type'
const { AND_OR } = StatementType
import FormActionType from '../model/form-action-type'
const {
	GO_TO_PAGE,
	CHANGE_WIDGET_VALIDATION,
	CHANGE_WIDGET_STATE,
	SET_FIELD_VALUE
} = FormActionType
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { TEXT } = FormWidgetType
import htmlToText from 'scoreboard/components/html-to-text'
import { truncateLongString } from 'scoreboard/reports/report-constants'
import '../../components/constants'
const WIDGET_HTML_MAX_LENGTH = 25
import DataType from 'scoreboard/datasets/model/data-type'
import constants from '../../components/constants'
import {getDialogDatasetOrDataset} from './pages-edit'
import KeyDisplay from '../../datasets/key-display'
const { DATE, TIME, DATE_TIME } = DataType
const {
	SPECIFIC_VALUE,
	CURRENT_DATE_TIME
} = constants.SET_FIELD_VALUE_TYPE

const FormActions = Backbone.View.extend({

	tagName: 'form',

	className: 'actions',

	events: {
		'click .add-statement-group': 'addStatementGroup',
		'click .statement-group': 'editStatementGroup',
		'click .delete': 'deleteStatementGroup'
	},

	/**
	 * The panel for modifying Page Display Actions, Button Click Actions, or
	 * Value Change Actions in the Forms section. Shows a list of conditional
	 * statements that can be used to modify the form
	 * @param options.currentWidget {Object} the widget that the actions
	 * form actions are tied to
	 */
	initialize: function(options = {}) {
		this.options = options
		this.dataset = getDialogDatasetOrDataset(this.model)
		this.statementGroups = _.cloneDeep(this.options.statements) ?? []
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.renderStatementGroups()
		return this
	},

	renderStatementGroups: function() {
		this.$('.statement-group-list').toggleClass('is-not-displayed', _.isEmpty(this.statementGroups))
		this.$('.no-statement-groups').toggleClass('is-not-displayed', !_.isEmpty(this.statementGroups))
		if (_.isEmpty(this.statementGroups)) return

		let html = ''
		_.each(this.statementGroups, sg => {
			html += '<li class="statement-group"><div class="content"><div>'

			_.each(sg, s => {
				html += this.getIfHtml(s, sg)
				html += this.getThenHtml(s, sg)
			})

			html += '</div></div>' + transformationButtons()
			html += '</li>'
		})
		this.$('.statement-group-list').html(html)
		this.draggableList = new DraggableList(this.$('.statement-group-list')[0])
		this.draggableList.on('move', (node, newIndex, prevIndex) => {
			reorderAfterDrag(this.statementGroups, newIndex, prevIndex)
			this.options.formView.change()
		})
	},

	addStatementGroup: function() {
		const logicianEditor = new FormLogicianEditor({
			model: this.model,
			title: this.options.title,
			allowedActionTypes: this.options?.allowedActionTypes,
			currentWidget: this.options.currentWidget
		})
		logicianEditor.on('done', (statements) => {
			this.statementGroups.push(statements)
			this.renderStatementGroups()
			this.options.formView.change()
		})
		appDisplay.dialog(logicianEditor)
	},

	editStatementGroup: function(e) {
		const { index } = this.getStatementGroupElAndIndex(e)
		const statements = this.statementGroups[index]
		const editor = new FormLogicianEditor({
			model: this.model,
			statements: statements,
			title: this.options.title,
			allowedActionTypes: this.options?.allowedActionTypes
		})
		editor.on('done', statements => {
			this.statementGroups[index] = statements
			this.renderStatementGroups()
			this.options.formView.change()
		})
		appDisplay.dialog(editor)
	},

	deleteStatementGroup: function(e) {
		e.stopPropagation()
		let { groupEl, index } = this.getStatementGroupElAndIndex(e)
		groupEl.remove()
		this.statementGroups.splice(index, 1)
		this.options.formView.change()
		this.renderStatementGroups()
	},

	getStatementGroupElAndIndex: function(e) {
		let groupEl = this.$(e.target).closest('.statement-group')
		let index = groupEl.index()
		return { groupEl, index }
	},

	/**
	 * gets the html for the conditions (i.e. If/Else if ____)
	 */
	getIfHtml: function(statement, statementGroup) {
		const groupSize = _.size(statementGroup)
		const statementIndex = _.indexOf(statementGroup, statement)

		// IF statement
		if (statementIndex == 0 && !_.isEmpty(statement.conditions)) {
			return this.getConditionsHtml(statement, false)

		// ELSE statement or not first ELSE IF statement
		} else if (statementIndex == groupSize - 1 || statementIndex > 1) {
			return ''

		// first ELSE IF statement
		} else {
			return this.getConditionsHtml(statement, true)
		}
	},

	/**
	 * gets the html for the form actions (i.e. Then/Else ____)
	 */
	getThenHtml: function(statement, statementGroup) {
		const groupSize = _.size(statementGroup)
		const statementIndex = _.indexOf(statementGroup, statement)

		// if this is not an else statement
		if (statementIndex != groupSize - 1) {
			// second if else shows ellipsis
			if (statementIndex == 2) return thenDisplay({ actionsString: '...' })

			// any other if else shows nothing
			if (statementIndex > 2) return ''
		}


		const actions = []
		_.forEach(statement.consequences, c => {
			actions.push(this.getActionText(c))
		})

		const hasConditions = !_.isEmpty(statement.conditions)
		let actionsString = _.join(actions, ', ')
		if (!hasConditions && groupSize == 1) actionsString = _.upperFirst(actionsString)
		return _.isEmpty(actions) ? '' :
			thenDisplay({
				actionsString,
				hasConditions,
				isElse: !hasConditions && groupSize != 1
			})
	},

	/**
	 * creates action text for the actions draggable list (i.e. go to the
	 * {} page, change the {} widget, etc. )
	 */
	getActionText: function(consequence) {
		const actionType = consequence.type
		const messageCode = `forms.actions.action-text.${actionType}`

		const args = []
		if (actionType === GO_TO_PAGE) {
			const pagesById = _.groupBy(this.model.get('pages'), 'id')
			args.push(pagesById[consequence.goToPageFormId][0].qualifiedLabel)
		}

		if (_.includes([CHANGE_WIDGET_STATE, CHANGE_WIDGET_VALIDATION], actionType)) {
			this.getWidgetText(consequence, actionType, args)
		}

		if (_.includes([SET_FIELD_VALUE], actionType)) {
			this.getSetFieldValueText(consequence, args)
		}

		return i18n.highlight(messageCode, ...args)
	},

	getWidgetText: function(consequence, actionType, args) {
		const { changeWidgetId, changeWidgetTempId, changeWidgetValidation,
			minimumLength, maximumLength, customExpression } = consequence
		const isCustomInputValidation =
			_.includes([MINIMUM_LENGTH, MAXIMUM_LENGTH, MINIMUM_MAXIMUM_LENGTH, CUSTOM_EXPRESSION], changeWidgetValidation)
		const changeWidget = _.isNil(changeWidgetId) ?
			_.groupBy(this.model.get('widgets'), 'tempId')[changeWidgetTempId][0] :
			_.groupBy(this.model.get('widgets'), 'id')[changeWidgetId][0]

		// #53554 use html for text widgets since they don't have a label
		const widgetLabel = changeWidget.type === TEXT ?
			truncateLongString(htmlToText(changeWidget.html),
				WIDGET_HTML_MAX_LENGTH) : changeWidget.label
		args.push(widgetLabel)

		const msgCode = actionType === CHANGE_WIDGET_STATE ?
			`forms.fieldWidget.type.${consequence.changeWidgetState}` :
			isCustomInputValidation ? `forms.widgets.inputValidation.${changeWidgetValidation}.arg`
				: `forms.widgets.inputValidation.${changeWidgetValidation}`
		if (isCustomInputValidation) {
			if (changeWidgetValidation === MINIMUM_MAXIMUM_LENGTH) {
				args.push(i18n.get(msgCode, minimumLength, maximumLength))
			} else if (changeWidgetValidation === MINIMUM_LENGTH) {
				args.push(i18n.get(msgCode, minimumLength))
			} else if (changeWidgetValidation === MAXIMUM_LENGTH) {
				args.push(i18n.get(msgCode, maximumLength))
			} else {
				args.push(i18n.get(msgCode, customExpression))
			}
		} else {
			args.push(i18n.get(msgCode))
		}
	},

	getSetFieldValueText: function(consequence, args) {
		const { setFieldValueFieldId, setFieldValue, setFieldValueType } = consequence
		let valueTypeText
		let field = this.dataset.getUnderlyingField(consequence.setFieldValueFieldId)
		let fieldDataType = field?.dataType
		let isDateTime = isDateTimeDataType(fieldDataType)
		let dateTimeFieldDataType = [DATE, TIME].includes(fieldDataType) ? fieldDataType : DATE_TIME

		let keyDisplay = new KeyDisplay({
			model: this.model.dataset,
			field,
			treeItemsById: this.model?.treeItemsById
		})
		let value = formatValue({
			value: setFieldValue,
			dataType: fieldDataType,
			keyDisplay
		})

		if (setFieldValueType === SPECIFIC_VALUE) {
			valueTypeText = value
		} else {
			if (setFieldValueType === SPECIFIC_VALUE) {
				valueTypeText = value
			} else if (isDateTime && setFieldValueType === CURRENT_DATE_TIME) {
				// Handle special messaging around date, time, and date_time fields
				valueTypeText = i18n.get(`forms.actions.action.set-field-value-type.current-${dateTimeFieldDataType}`)
			} else {
				valueTypeText = i18n.get(`forms.actions.action.set-field-value-type.${setFieldValueType}`)
			}

			// Check to see if the message resource wasn't properly retrieved
			// because, for some reason, the data type is not supported
			if (valueTypeText.includes('forms.actions.action.set-field-value-type.')) {
				valueTypeText = i18n.get(`forms.actions.action.set-field-value-type.invalid-data-type`)
			}
		}
		args.push(this.dataset.getFieldLabel(setFieldValueFieldId))
		args.push(valueTypeText)
	},

	getConditionsHtml: function(statement, elseIf) {
		if (_.isEmpty(statement.conditions)) return ''

		// If/Else if ...
		const beginning = i18n.get(elseIf ? 'logic.elseIf' : 'common.if')
		let html = `<div class="if-display subtitle">${beginning}&nbsp;`

		let conditions = []
		let group = []

		// group the conditions by linkGroup so we can join on an and/or
		let linkGroup = statement.conditions[0].linkGroup
		_.forEach(statement.conditions, c => {
			if (c.linkGroup != linkGroup) {
				conditions.push(group)
				group = []
				linkGroup = c.linkGroup
			}
			const field = this.dataset.getUnderlyingField(c.fieldId)

			const context = getIfContext(c, field, {
				dataset: this.dataset,
				treeItemsById: this.model.treeItemsById
			})

			// in-another-tree operators aren't used in this context so add in
			// the operatorKey here
			if (c?.operator === 'in-another-tree') context.operatorKey = 'common.is'
			else if (c?.operator === 'not-in-another-tree') context.operatorKey = 'common.isNot'

			group.push(ifDisplay(context))
		})
		if (!_.isEmpty(group)) conditions.push(group)

		// and/or conditions together, wrap in parens if multiple conditions
		conditions = _.map(conditions, g => {
			const innerCode = statement.statementType === AND_OR ? 'common.or' : 'common.and'
			const wrap = _.size(g) > 1
			let value = g.join(`<span>&nbsp;${_.lowerCase(i18n.get(innerCode))}&nbsp;</span>`)
			if (wrap) value = `(${value})`
			return value
		})

		// and/or the linkGroups together
		const outerCode = statement.statementType === AND_OR ? 'common.and' : 'common.or'
		html += conditions.join(`<span>&nbsp;${_.lowerCase(i18n.get(outerCode))}&nbsp;</span>`)

		html += '</div>'
		return html
	},

	context: function() {
		return {
			title: this.options.title,
			emptyMessage: this.options.emptyMessage
		}
	},

	getData: function() { return this.statementGroups },

	autoRemove: true

})

export default FormActions
FormActions.__filename__ = 'forms/edit/form-actions.js'
